import * as yup from 'yup';

import { requiredStringField } from './commons';

export const settingsNaturalOtherRoleSchema = yup.object({
  email: requiredStringField,
  firstName: requiredStringField,
  lastName: requiredStringField,
});
